@if (kiosk()) {
  <router-outlet />
} @else {
  <app-nav style="height: 100%"></app-nav>
}
<ngx-spinner bdColor="#b71c1c" size="large" color="#fff" type="ball-pulse-sync"> </ngx-spinner>
